const styles = (theme) => ({
  name: {
    ...theme.typography.h6,
  },
});

export default styles;
